import { findBrandByDomain } from "../../../../configs/configLoader";

interface GenderButtonProps {
  gender: string;
  selectedGender: string | null;
  baseStyles: React.CSSProperties;
  hovered: string | null;
  setHovered: (val: string | null) => void;
  label: string;
  onSelect: () => void;
  tabIndex?: number;
}

const GenderButton: React.FC<GenderButtonProps> = ({
  gender,
  selectedGender,
  baseStyles,
  hovered,
  setHovered,
  label,
  onSelect,
  tabIndex = 0,
}) => {
  const isSelected = selectedGender === gender;
  const isHovered = hovered === gender;

  const brandDefined = findBrandByDomain();

  const isIntersport = brandDefined?.name === "Intersport";
  const isBlackstore = brandDefined?.name === "Blackstore";
  const isCustomInterface = isIntersport || isBlackstore;

  const isPeserico = brandDefined?.name === "Peserico";
  const isGivenchy = brandDefined?.name === "Givenchy";
  const isTDF = brandDefined?.name === "TDF";

  const styles: React.CSSProperties = {
    ...baseStyles,
    textTransform:
      baseStyles.textTransform === "capitalize"
        ? "none"
        : baseStyles.textTransform,
    borderColor:
      isHovered && isCustomInterface ? "#A1A1A1" : baseStyles.borderColor,
    padding: isPeserico ? "12px 16px" : "10px 20px",
    minHeight: isTDF ? "28px" : isGivenchy ? "40px" : "45px",
    justifyContent: "center",
  };

  return (
    <button
      tabIndex={tabIndex}
      type="button"
      className={`gender-btn ${isSelected ? "selected" : ""}`}
      style={styles}
      onClick={onSelect}
      onMouseEnter={() => setHovered(gender)}
      onMouseLeave={() => setHovered(null)}
    >
      {label}
    </button>
  );
};

export default GenderButton;
